export default "__VITE_ASSET__BA0krj7p__"